import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const MailIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 14, height = 12, stroke = "#1677FF", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1 2.66634C1 2.31272 1.14048 1.97358 1.39052 1.72353C1.64057 1.47348 1.97971 1.33301 2.33333 1.33301H11.6667C12.0203 1.33301 12.3594 1.47348 12.6095 1.72353C12.8595 1.97358 13 2.31272 13 2.66634M1 2.66634V9.33301C1 9.68663 1.14048 10.0258 1.39052 10.2758C1.64057 10.5259 1.97971 10.6663 2.33333 10.6663H11.6667C12.0203 10.6663 12.3594 10.5259 12.6095 10.2758C12.8595 10.0258 13 9.68663 13 9.33301V2.66634M1 2.66634L7 6.66634L13 2.66634"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
